import React from "react";
import Slider from "react-slick";
import "./HeroCarousel.scss";
import carouselImage1 from '../../assets/images/banners/1752127805_cropped_image.jpg';
import carouselImage2 from '../../assets/images/banners/1752127837_cropped_image.jpg';
import carouselImage3 from '../../assets/images/banners/1752127996_cropped_image.jpg';


const HeroCarousel = ({ }) => {

  const homepageSlides = [
  {
    image: carouselImage1,
    title: "आपके घर, गाड़ी और सेहत की सुरक्षा — हमारी सबसे बड़ी ज़िम्मेदारी",
    subtitle: "घर, गाड़ी या सेहत – हमारी बीमा सेवाएं हर कदम पर आपके साथ हैं। भरोसेमंद कवरेज और आसान क्लेम प्रोसेस के साथ, हम आपके कल को सुरक्षित बनाते हैं।",
    cta: "GET STARTED",
    ctaLink: "/aboutus",
  },
  {
    image: carouselImage2,
    title: "सुरक्षित सफर की शुरुआत यहीं से होती है",
    subtitle: "दूर देश या पास का शहर – हर यात्रा के लिए मिले संपूर्ण सुरक्षा। हमारे ट्रैवल इंश्योरेंस के साथ सफर बनाएं बेफिक्र और सुरक्षित।",
    cta: "GET STARTED",
    ctaLink: "/aboutus",
  },
  {
    image: carouselImage3,
    title: "हर जरूरत के लिए एक भरोसेमंद बीमा समाधान",
    subtitle: "चाहे घर हो या दुकान, यात्रा हो या वाहन – हम आपके हर मूल्यवान संपत्ति और पल की सुरक्षा के लिए हैं। आसान प्रोसेस, तेज क्लेम और पूरी पारदर्शिता के साथ, हम देते हैं बीमा जिस पर आप भरोसा कर सकते हैं।",
    cta: "GET STARTED",
    ctaLink: "/aboutus",
  },
];

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, 
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          arrows: false,
          dots: true,
        },
      },
    ],
  };


  return (
    <div>
       <div className="container">
    <section className="hero-carousel">
      <Slider {...settings}>
        {homepageSlides.map((slide, index) => (
          <div key={index} className="hero-slide">
            <img
              src={slide.image}
              alt={slide.title || `Slide ${index + 1}`}
              className="hero-slide-img"
            />
            {slide.title && (
              <div className="hero-slide-content">
                <h2>{slide.title}</h2>
                <p>{slide.subtitle}</p>
                {slide.cta && (
                  <a href={slide.ctaLink} className="hero-slide-btn">
                    {slide.cta}
                  </a>
                )}
              </div>
            )}
          </div>
        ))}
      </Slider>
    </section>
    </div>
    </div>
  );
};

export default HeroCarousel;